import { floatToPercent } from './floatToPercent'

export const displayAsPercent = (number: number | undefined): string | null => {
  if (!number) return null
  return `${floatToPercent(number)}%`
}
